<form #f="ngForm" style="padding-top:-20px;">
    <div>
        <div class="p-grid">
            <div class="p-col-12 error-notify-text">
                <app-validateform #fValidator1 [formToValidate]="dealEditForm"></app-validateform>
            </div>
        </div>
        <div *ngIf="deal">
            <div class="p-grid">
                <div class="p-col-12 p-lg-2 p-md-2 p-sm-2" *ngIf="deal.DealStatusID<4">
                    <button pButton type="button" class="fullwidthbtn" label="Save" (click)="saveDeal()"></button>
                </div>
                <div class="p-col-12 p-lg-2 p-md-2 p-sm-2" *ngIf="deal.DealStatusID==1">
                    <button pButton type="button" class="fullwidthbtn" label="Save And Propose" (click)="saveAndPropose()"></button>
                </div>
                <div class="p-col-12 p-lg-2 p-md-2 p-sm-2" *ngIf="deal.DealStatusID>2||isAdmin">
                    <button pButton type="button" class="fullwidthbtn" label="Save & Close" (click)="showCloseDealDialog()"></button>
                </div>
                <div class="p-col-12 p-lg-2 p-md-2 p-sm-2" *ngIf="isAdmin">
                    <button [disabled]="!hasMorePermission" pButton type="button" class="fullwidthbtn" label="Delete" (click)="deleteDeal()"></button>
                </div>
                <div class="p-col-12 p-lg-2 p-md-2 p-sm-2">
                    <button pButton type="button" class="fullwidthbtn" label="Cancel" (click)="cancelEdit()"></button>
                </div>
            </div>
            <div>
                <p-accordion [multiple]="true">
                    <p-accordionTab header="DEAL" [selected]="true">
                        <div class="p-grid">
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.Title"
                                           name="Title"
                                           requiredNoSpaceValidator
                                           data-display-name="Deal Title" />
                                    <label for="float-input">Title*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="dealTypeOptions"
                                                [(ngModel)]="deal.DealTypeID"
                                                name="DealTypeID"
                                                required
                                                data-display-name="Deal Type"
                                                appendTo="body">
                                    </p-dropdown>
                                    <label for="dropdown">Type*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.FinalDealValue"
                                               name="FinalDealValue" />
                                        <span class="p-inputgroup-addon">$</span>
                                        <label for="textinput">Final Value</label>
                                    </span>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <span class="p-float-label">
                                    <p-calendar inputId="calendar"
                                                [(ngModel)]="deal.EstimatedCloseDate"
                                                name="EstimatedCloseDate"
                                                required
                                                data-display-name="Deal Estimated Close Date"
                                                styleClass="fullwidthbtn">
                                    </p-calendar>
                                    <label for="calendar">Estimated Close Date*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.CommissionProposer"
                                               name="CommissionProposer"
                                               required
                                               data-display-name="Deal Commission Spit to Proposer"
                                               (keyup)="CommissionKeyup(1)" />
                                        <span class="p-inputgroup-addon">%</span>
                                        <label for="textinput">Commission Spit to Proposer*</label>
                                    </span>

                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.CommissionReceiver"
                                               name="CommissionReceiver"
                                               required
                                               data-display-name="Deal Commission Spit to Receiver"
                                               (keyup)="CommissionKeyup(2)" />
                                        <span class="p-inputgroup-addon">%</span>
                                        <label for="textinput">Commission Spit to Receiver*</label>
                                    </span>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.CommissionNAI"
                                               name="CommissionNAI"
                                               [disabled]="!isAdmin" />
                                        <span class="p-inputgroup-addon">%</span>
                                        <label for="textinput">Commission Spit to NAI</label>
                                    </span>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.EstimatedCommission"
                                               name="EstimatedCommission"
                                               required
                                               data-display-name="Deal Estimated Commission" />
                                        <span class="p-inputgroup-addon">$</span>
                                        <label for="textinput">Estimated Commission*</label>
                                    </span>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.FinalCommission"
                                               name="FinalCommission" />
                                        <span class="p-inputgroup-addon">$</span>
                                        <label for="textinput">Final Commission</label>
                                    </span>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.ValueHigh"
                                               name="ValueHigh" />
                                        <span class="p-inputgroup-addon">$</span>
                                        <label for="textinput">Value High</label>
                                    </span>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.ValueLow"
                                               name="ValueLow" />
                                        <span class="p-inputgroup-addon">$</span>
                                        <label for="textinput">Value Low</label>
                                    </span>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.EstimatedDealValue"
                                               name="EstimatedDealValue" />
                                        <span class="p-inputgroup-addon">$</span>
                                        <label for="textinput">Estimated Deal Value</label>
                                    </span>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-field-checkbox">
                                    <p-checkbox [(ngModel)]="deal.PaymentReceived"
                                                binary="true"
                                                inputId="binary"
                                                name="PaymentReceived"                                                
                                                (onChange)="PaymentReceivedOnChange()">
                                    </p-checkbox>
                                    <label for="binary">Payment Received</label>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <span class="p-float-label">
                                    <p-calendar inputId="calendar"
                                                [(ngModel)]="deal.PaymentReceivedDate"
                                                name="PaymentReceivedDate"
                                                styleClass="fullwidthbtn"
                                                [disabled]="!deal.PaymentReceived">
                                    </p-calendar>
                                    <label for="calendar">Payment Received Date</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.PaymentAmount"
                                               name="PaymentAmount" />
                                        <span class="p-inputgroup-addon">$</span>
                                        <label for="textinput">Payment Amount</label>
                                    </span>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-field-checkbox">
                                    <p-checkbox [(ngModel)]="deal.DocumentReceived"
                                                binary="true"
                                                inputId="binary"
                                                name="DocumentReceived"
                                                lable="Document Received"
                                                (onChange)="DocumentReceivedOnChange()">
                                    </p-checkbox>
                                    <label for="binary">Document Received</label>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <span class="p-float-label">
                                    <p-calendar inputId="calendar"
                                                [(ngModel)]="deal.DocumentReceivedDate"
                                                name="DocumentReceivedDate"
                                                styleClass="fullwidthbtn"
                                                [disabled]="!deal.DocumentReceived">
                                    </p-calendar>
                                    <label for="calendar">Document Received Date</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input inputId="textinput"
                                               type="number"
                                               pInputText
                                               [(ngModel)]="deal.FlatFee"
                                               name="FlatFee"
                                               [disabled]="!isAdmin"/>
                                        <span class="p-inputgroup-addon">$</span>
                                        <label for="textinput">Flat Fee</label>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </p-accordionTab>
                    <p-accordionTab header="PROPERTY" [selected]="true">
                        <div class="p-grid">
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.PropertyAddress"
                                           name="PropertyAddress"                                          
                                           data-display-name="Property Address" />
                                    <label for="float-input">Address</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.PropertyAddress2"
                                           name="PropertyAddress2" />
                                    <label for="float-input">Address 2</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.PropertyCity"
                                           name="PropertyCity"
                                           requiredNoSpaceValidator
                                           data-display-name="Property City" />
                                    <label for="float-input">City*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-3 p-md-3">
                                <div *ngIf="stateOptions&&stateOptions.length>0;else stateTextBox">
                                    <span class="p-float-label">
                                        <p-dropdown inputId="dropdown"
                                                    [autoDisplayFirst]="false"
                                                    [showClear]="true"
                                                    [options]="stateOptions"
                                                    [(ngModel)]="deal.PropertyStateID"
                                                    name="PropertyStateID"
                                                    data-display-name="Property State"
                                                    appendTo="body">
                                        </p-dropdown>
                                        <label for="dropdown">State*</label>
                                    </span>
                                </div>
                                <ng-template #stateTextBox>
                                    <div>
                                        <span class="p-float-label">
                                            <input type="text"
                                                   pInputText
                                                   [(ngModel)]="deal.PropertyState"
                                                   name="PropertyState"
                                                   data-display-name="Property State" />
                                            <label for="float-input">State*</label>
                                        </span>
                                    </div>
                                </ng-template>

                            </div>
                            <div class="p-col-12 p-lg-3 p-md-3">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.PropertyZip"
                                           name="PropertyZip" />
                                    <label for="float-input">Zip</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-3 p-md-3">
                                <span class="p-float-label">
                                    <p-dropdown filter=true
                                                inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [options]="countryOptions"
                                                [(ngModel)]="deal.PropertyCountryID"
                                                name="PropertyCountryID"
                                                required
                                                data-display-name="Property Country"
                                                appendTo="body"
                                                (onChange)="onChangeCountry()">
                                    </p-dropdown>
                                    <label for="dropdown">Country*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-3 p-md-3">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="unitOfMeasurementTypeOptions"
                                                [(ngModel)]="deal.UnitOfMesureID"
                                                name="UnitOfMesureID"
                                                required
                                                data-display-name="Property Unit Of Mesure"
                                                appendTo="body">
                                    </p-dropdown>
                                    <label for="dropdown">Unit Of Mesure*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-3 p-md-3">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.EstimatedSize"
                                           name="EstimatedSize"
                                           requiredNoSpaceValidator
                                           data-display-name="Property Size" />
                                    <label for="float-input">Size*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-3 p-md-3">
                                <span class="p-float-label">
                                    <p-dropdown inputId="dropdown"
                                                [autoDisplayFirst]="false"
                                                [showClear]="true"
                                                [options]="propertyTypeOptions"
                                                [(ngModel)]="deal.PropertyTypeID"
                                                name="PropertyTypeID"
                                                required
                                                data-display-name="Property Type"
                                                appendTo="body">
                                    </p-dropdown>
                                    <label for="dropdown">Type*</label>
                                </span>
                            </div>
                        </div>
                    </p-accordionTab>
                    <p-accordionTab header="BROKER" [selected]="true">
                        <div class="p-grid">
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <div class="p-grid">
                                    <div class="p-col-3" style="margin-top: 7px;">
                                        <label>Sending Broker*</label>
                                    </div>
                                    <div class="p-col-9">
                                        <button pButton type="button"
                                                class="fullwidthbtn"
                                                label="{{getBrokerName(sendingBroker)}}"
                                                (click)="showSearchBrokerDialog(1)"
                                                [disabled]="!hasMorePermission"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <div class="p-grid">
                                    <div class="p-col-3" style="margin-top: 7px;">
                                        <label>Receiving Broker*</label>
                                    </div>
                                    <div class="p-col-9">
                                        <button pButton
                                                type="button"
                                                class="fullwidthbtn"
                                                label="{{getBrokerName(receivingBroker)}}"
                                                (click)="showSearchBrokerDialog(2)"
                                                name="ReceivingBroker"
                                                required
                                                data-display-name="Receiving Broker">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-accordionTab>
                    <p-accordionTab header="CLIENT" [selected]="true">
                        <div class="p-grid">
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.ClientCoName"
                                           name="ClientCoName"
                                           requiredNoSpaceValidator
                                           data-display-name="Client Name" />
                                    <label for="float-input">Name*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.ClientCoLocation"
                                           name="ClientCoLocation" />
                                    <label for="float-input">Location</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-6 p-md-6">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.ClientContactName"
                                           name="ClientContactName"
                                           requiredNoSpaceValidator
                                           data-display-name="Client Company Name" />
                                    <label for="float-input">Company Name*</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-4 p-md-4">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.ClientContactEmail"
                                           name="ClientContactEmail"
                                           emailValidator
                                           data-display-name="Client Email" />
                                    <label for="float-input">Email</label>
                                </span>
                            </div>
                            <div class="p-col-12 p-lg-2 p-md-4">
                                <span class="p-float-label">
                                    <input type="text"
                                           pInputText
                                           [(ngModel)]="deal.ClientContactPhone"
                                           name="ClientContactPhone" />
                                    <label for="float-input">Phone</label>
                                </span>
                            </div>
                        </div>
                    </p-accordionTab>
                </p-accordion>
            </div>
        </div>
    </div>

</form>

<p-dialog [breakpoints]="{'960px': '100vw'}" styleClass="dialog-medium" draggable="false" modal="true" [closable]="false" header="{{(searchBrokerType == 1) ? 'Search Sending Broker' : 'Search Receiving Broker'}}" [(visible)]="searchBrokerDialogVisible">
    <p-divider></p-divider>
    <div class="p-grid">
        <div class="p-col-12 error-notify-text" *ngIf="searchBrokerDialogMessage.length>0">
            {{searchBrokerDialogMessage}}
        </div>
        <div class="p-col-6">
            <span class="p-float-label">
                <input type="text"
                    pInputText
                    [(ngModel)]="searchBrokerText"
                    name="searchBrokerText"
                    (keyup.enter)="searchBroker()" />
                  <label for="float-input">Search Brokers By Name</label>
                </span>
        </div>
        <div class="p-col-2">
            <button pButton type="button" icon="pi pi-search" iconPos="left" (click)="searchBroker()"></button>
        </div>
        <div class="p-col-4" *ngIf="searchByLocationVisible">
            <button pButton type="button" class="fullwidthbtn" label="Search by Deal Address" (click)="getbrokerListByDealAddress()"></button>
        </div>
        <div class="p-col-12" *ngIf="searchBrokerResultList.length>0">
            <p-dataView #dv [value]="searchBrokerResultList"
                        [paginator]="true"
                        filterBy="FName,LName"
                        [rows]="5"
                        [showCurrentPageReport]="true"
                        [rowsPerPageOptions]="rowsPerPageOptions"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                <ng-template let-broker pTemplate="listItem">
                    <div class="p-col-12">
                        <div class="object-list-item">
                            <img class="profilePicture" [src]="'data:image/png;base64,' + broker.ProfilePicture" style="height: 75px; width: 75px;" />
                            <div class="object-list-detail">
                                 <div class="">{{getBrokerName(broker)}}</div>
                                 <div class=""><b>{{getMemberName(broker)}}</b></div>
                                 <div class=""><b>Email: </b>{{broker.Email}}</div>
                                 <div class=""><b>Phone: </b>{{broker.DirectPhone}}</div>
                            </div>
                            <div class="object-list-action">
                                <p-button label="Select" (click)="selectBroker(broker)"></p-button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-dataView>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancel" (click)="hideSearchBrokerDialog()"></button>
    </ng-template>
</p-dialog>

<form #f1="ngForm">
    <p-dialog [breakpoints]="{'960px': '100vw'}" styleClass="dialog-medium" draggable="false" modal="true" [closable]="false"
              header="Close Deal" [(visible)]="closeDealDialogVisible">
        <p-divider></p-divider>
        <div class="p-grid">
            <div class="p-col-12 error-notify-text">
                <app-validateform #fValidator2 [formToValidate]="dealCloseDialogForm"></app-validateform>
            </div>
            <div class="p-col-12">
                <div class="p-grid">
                    <div class="p-col-12">
                        <span class="p-float-label">
                            <p-calendar inputId="calendar"
                                        [(ngModel)]="deal.ExecutionDate"
                                        name="ExecutionDate"
                                        required
                                        data-display-name="Final Close Date"
                                        styleClass="fullwidthbtn"
                                        appendTo="body">
                            </p-calendar>
                            <label for="calendar">Final Close Date*</label>
                        </span>
                    </div>
                    <div class="p-col-12">
                        <span class="p-float-label">
                            <input inputId="textinput"
                                   type="number"
                                   pInputText
                                   [(ngModel)]="deal.FinalCommission"
                                   name="FinalCommission"
                                   requiredNoSpaceValidator
                                   data-display-name="Final Commission" />
                            <label for="textinput">Final Commission</label>
                        </span>
                    </div>
                    <div class="p-col-12">
                        <span class="p-float-label">
                            <input inputId="textinput"
                                   type="number"
                                   pInputText
                                   [(ngModel)]="deal.FinalDealValue"
                                   name="FinalDealValue"
                                   requiredNoSpaceValidator
                                   data-display-name="Final Deal Value" />
                            <label for="textinput">Final Deal Value</label>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton type="button" label="Submit" (click)="saveAndCloseDeal()"></button>
            <button pButton type="button" label="Cancel" (click)="hideCloseDealDialog()"></button>
        </ng-template>
    </p-dialog>
</form>

<p-confirmDialog header="Confirmation" icon="ui-icon-warning" width="800"></p-confirmDialog>


